class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.sectionWrapper = this.querySelector('[data-section-wrapper]');
    this.carousel = this.querySelector('products-slider');
    this.sectionWrapper.classList.add('visually-hidden');

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('products-slider');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.carousel.innerHTML = recommendations.innerHTML;
            this.carousel.initSlider();
            this.sectionWrapper.classList.remove('visually-hidden');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
